import { calcularValorDescontoAnual } from "../../../../functions/usinas/CalcularValorDescontoAnual";
import { getDataDescontoElegivelMercadoLivre } from "../../../../functions/usinas/ConfigureLeadMercadoLivre";
import { filtrarMelhorContratoPlanoUsina } from "../../../../functions/usinas/FiltrarMelhorContratoPlanoUsina";
import { filtrarPlanoUsinasContrataveis } from "../../../../functions/usinas/FiltrarPlanoUsinasContrataveis";
import { filtrarPlanoUsinasDisponiveisTipoPfPj } from "../../../../functions/usinas/FiltrarPlanoUsinasDisponiveisTipoPfPj";

export const statusSimulacao = {
  empty_inputs: "empty_inputs", // falta preencher campos
  regiao_nao_atendida: "regiao_nao_atendida",
  sem_estoque: "sem_estoque",
  sem_consumo_minimo: "sem_consumo_minimo",
  tipo_pf_pj_indisponivel: "tipo_pf_pj_indisponivel",
  zero_value: "zero_value",
};

export const configSimulacao = async ({
  formData,
  setFormData,
  concessionariaId,
}) => {
  if (formData?.valorConsumo == 0) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoFail(statusSimulacao.zero_value),
    });
  }
  if (
    !formData?.selectedTypeButton?.selected ||
    !formData.valorConsumo ||
    !formData?.dataConfigOfertas
  ) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoFail(statusSimulacao.empty_inputs),
    });
  }

  const { mlRules, planoUsinasConcessionarias, planoUsinasDisponiveis } =
    formData.dataConfigOfertas;

  const dataMercadoLivre = await getDataDescontoElegivelMercadoLivre({
    tipoConta: formData?.selectedTypeButton?.selected,
    consumoDinheiro: formData.valorConsumo,
    info: mlRules,
  });
  if (dataMercadoLivre.elegivel) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoOk(dataMercadoLivre.valorDesconto),
    });
  }

  if (!isRegiaoAtendida({ planoUsinasConcessionarias })) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoFail(statusSimulacao.regiao_nao_atendida),
    });
  }

  if (!hasStock({ planoUsinasDisponiveis })) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoFail(statusSimulacao.sem_estoque),
    });
  }

  // Tipo de contratação indisponível (consumo_minimo_[pf/pj] está zerado)? PF/PJ
  const planoUsinasDisponiveisTipoPfPj =
    await filtrarPlanoUsinasDisponiveisTipoPfPj({
      planoUsinas: planoUsinasDisponiveis,
      tipoConta: formData?.selectedTypeButton?.selected,
    });
  if (planoUsinasDisponiveisTipoPfPj.length === 0) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoFail(statusSimulacao.tipo_pf_pj_indisponivel),
    });
  }

  const planoUsinasContrataveis = await filtrarPlanoUsinasContrataveis({
    planoUsinas: planoUsinasDisponiveisTipoPfPj,
    consumoDinheiro: formData.valorConsumo,
    concessionariaId: concessionariaId,
    tipoConta: formData?.selectedTypeButton?.selected,
  });

  if (planoUsinasContrataveis.length == 0) {
    return setFormData({
      ...formData,
      dataDiscount: dataDescontoFail(statusSimulacao.sem_consumo_minimo),
    });
  }

  const melhorContratoPlanoUsina = await filtrarMelhorContratoPlanoUsina({
    planoUsinas: planoUsinasContrataveis,
    tipoConta: formData?.selectedTypeButton?.selected,
  });
  const valorDesconto = calcularValorDescontoAnual({
    porcentagem:
      melhorContratoPlanoUsina.attributes?.[
        `desconto_porcentagem_${formData?.selectedTypeButton?.selected}`
      ],
    consumoDinheiro: formData.valorConsumo,
  });

  // if (valorDesconto <= 0) {
  //   return setFormData({
  //     ...formData,
  //     dataDiscount: dataDescontoFail(statusSimulacao.sem_consumo_minimo),
  //   });
  // }

  setFormData({
    ...formData,
    dataDiscount: dataDescontoOk(valorDesconto),
  });
};

function isRegiaoAtendida({ planoUsinasConcessionarias }) {
  if (!planoUsinasConcessionarias) {
    return false;
  }

  if (planoUsinasConcessionarias.length == 0) {
    return false;
  }

  return true;
}

function hasStock({ planoUsinasDisponiveis }) {
  if (!planoUsinasDisponiveis) {
    return false;
  }

  if (planoUsinasDisponiveis.length == 0) {
    return false;
  }

  return true;
}

function dataDescontoFail(message) {
  return {
    status: false,
    message,
  };
}

function dataDescontoOk(valorDescontoAnual) {
  return {
    status: true,
    valorDescontoAnual: Math.round(valorDescontoAnual),
  };
}
